import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { EventTickerItem } from './event-ticker.types';
import { EventTickerService } from './event-ticker.service';

@Component({
    selector: 'event-ticker',
    templateUrl: './event-ticker.component.html',
    styles: [`
        .ticker-wrap {
            width: 100%;
            overflow: hidden;
            height: 24px;
            display: flex;
            align-items: center;
        }
        .ticker-wrap:hover .ticker {
            animation-play-state: paused;
        }
        .ticker {
            display: inline-block;
            white-space: nowrap;
            animation: ticker 80s linear infinite;
        }
        .ticker__item {
            display: inline-block;
            padding: 0 3rem;
        }
        @keyframes ticker {
            0% {
                transform: translateX(0);
            }
            100% {
                transform: translateX(-50%);
            }
        }
    `],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgFor, NgIf, NgClass]
})
export class EventTickerComponent implements OnInit, OnDestroy {
    @Input() set events(val: EventTickerItem[]) {
        if (val !== undefined && val !== null) {
            this._customEvents = val;
            this.eventsList = val;
            this._changeDetectorRef.markForCheck();
        }
    }
    get events(): EventTickerItem[] {
        return this.eventsList;
    }

    eventsList: EventTickerItem[] = [];
    private _customEvents: EventTickerItem[] | null = null;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _eventTickerService: EventTickerService,
        private _changeDetectorRef: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this._eventTickerService.events$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((serviceEvents) => {
                if (this._customEvents === null) {
                    this.eventsList = serviceEvents || [];
                    this._changeDetectorRef.markForCheck();
                }
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
